import axios from 'axios'
import type {
  ImportRunPaginatedRequest,
  ImportRunPaginatedResponse,
  LatestImportRunsResponse,
} from 'types'

export const importRunList = (request: ImportRunPaginatedRequest) =>
  axios
    .get<ImportRunPaginatedResponse>('/api/import-runs', { params: request })
    .then((res) => res.data)

export const importRunsLatest = () =>
  axios
    .get<LatestImportRunsResponse>('/api/import-runs/latest')
    .then((res) => res.data)
